module.exports = __webpack_public_path__ + "img/yuanda_5.06ec8313.png";